import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import { QUERY_STRINGS } from "../../constants";
import consultantsService from "../../services/consultants";
import { SnackbarState, useSnackbar } from "../../store/useSnackbar";
import { ErrorContent } from "../../types/default";

const addSnackbarSelector = (state: SnackbarState) => state.addSnackbar;

export const useMakeAnOffer = () => {
  const { t } = useTranslation();
  const addSnackbar = useSnackbar(addSnackbarSelector);

  const { mutate: makeAnOffer, isLoading } = useMutation(consultantsService.makeAnOffer, {
    mutationKey: QUERY_STRINGS.MAKE_AN_OFFER,
    onError: (error: ErrorContent) => addSnackbar({ text: error.message }),
    onSuccess: () => addSnackbar({ type: "success", text: t("userProfile:actions.makeAnOffer.makeAnOfferSent") }),
  });

  return { makeAnOffer, isLoading };
};
